import React, { ReactNode } from 'react';

export interface MobileCardCellProps {
  label?: ReactNode;
  isTitle?: boolean;
  // react-data-table-component only fires row clicks when the tapped element carries data-tag="allowRowEvents".
  dataTag?: string;
  children?: ReactNode;
}

// One "label: value" line of a table row rendered as a card on phones.
export function MobileCardCell(props: MobileCardCellProps) {
  const { label, isTitle = false, dataTag, children } = props;
  const hasLabel = !isTitle && (typeof label === 'string' || typeof label === 'number') && String(label).trim() !== '';
  const className = isTitle ? 'gc-card-cell gc-card-cell--title' : hasLabel ? 'gc-card-cell' : 'gc-card-cell gc-card-cell--bare';
  return (
    <div className={className} data-tag={dataTag}>
      {hasLabel && (
        <div className="gc-card-cell__label" data-tag={dataTag}>
          {label}
        </div>
      )}
      <div className="gc-card-cell__value" data-tag={dataTag}>
        {children}
      </div>
    </div>
  );
}

export function isTextLabel(label: ReactNode): boolean {
  return typeof label === 'string' && label.trim() !== '';
}
